import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogTitle
} from "@mui/material";
import {
    useRef,
    useState
} from "react";

import { IssueCard } from "../IssueCard";
import { LoadingButton } from "@mui/lab";
import { useIssues } from "../contexts/IssuesContextProvider";
import { useSubmitDimensions } from "../data/hooks/useSubmitDimensions";

interface ProcureDimensionsModalProps {
    issueId: string;
    showModal: boolean;
    handleClose: () => void;
}

export const ProcureDimensionsModal = ({ showModal, handleClose, issueId }: ProcureDimensionsModalProps) => {
    const { issueIdToIssueMap, resourceIdToImageMap } = useIssues();
    const { submitDimensions } = useSubmitDimensions();
    const [isLoading, setIsLoading] = useState(false);
    const formRef = useRef<HTMLFormElement>(null);

    const issue = issueIdToIssueMap.get(issueId);
    if (!issue) {
        return null;
    }

    const handleSubmit = async () => {
        if (!formRef.current) return;

        setIsLoading(true);
        try {
            const formData = new FormData(formRef.current);
            await submitDimensions?.(issue.id, formData);
            handleClose();
        } catch (error) {
            console.error("Error submitting dimensions:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog
            open={showModal}
            onClose={handleClose}
            disablePortal
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>
                Edit Dimensions
            </DialogTitle>
            <Box display="flex" alignItems="center" flexDirection="column" p={2}>
                <IssueCard
                    issue={issue}
                    images={resourceIdToImageMap.get(issue.id) ?? []}
                    inFocus={false}
                    hideQuickQuote
                    showDimensionsForm
                    dimensionFormRef={formRef}
                />
            </Box>
            <DialogActions>
                <Button color="error" variant="outlined" onClick={handleClose}>
                    Cancel
                </Button>
                <LoadingButton
                    sx={{
                        maxWidth: "100px",
                        maxHeight: "40px",
                        alignSelf: "center"
                    }}
                    variant="contained"
                    onClick={handleSubmit}
                    loading={isLoading}
                >
                    {isLoading ? "Submitting..." : "Submit"}
                </LoadingButton>
            </DialogActions>
        </Dialog >
    );
};